import { PDF_CONTENT_TYPE } from '@/domain/model/CourseDocument';

export const ACCEPTED_DOCUMENT_TYPES = PDF_CONTENT_TYPE;

export const documentFileKey = (file: File): string =>
  `${file.name}-${file.size}-${file.lastModified}`;
